import axios, { AxiosPromise } from 'axios';

/**
 * Accès aux métriques via l'actuator natif Micrometer (`/management/metrics`), qui a remplacé
 * l'ancien endpoint agrégé jhipster `/management/jhimetrics` (retiré avec jhipster-framework).
 *
 * <p>L'endpoint Micrometer expose une liste de meters, à interroger un par un (éventuellement filtrés
 * par tags). L'agrégation vers la forme attendue par la page est faite côté composant.
 */
export default class MetricsService {
  /** Liste des noms de meters disponibles. */
  public getMetricNames(): AxiosPromise<{ names: string[] }> {
    return axios.get('management/metrics');
  }

  /**
   * Détail d'un meter, éventuellement filtré par tags au format « clé:valeur ».
   * @return measurements (statistic/value) + availableTags.
   */
  public getMetric(name: string, tags: string[] = []): AxiosPromise<any> {
    const query = tags.length ? '?' + tags.map(t => 'tag=' + encodeURIComponent(t)).join('&') : '';
    return axios.get(`management/metrics/${encodeURIComponent(name)}${query}`);
  }

  public retrieveThreadDump(): AxiosPromise<any> {
    return axios.get('management/threaddump');
  }
}
